import React from 'react'

export const PointerCircle = ({hex, hsl}) => {
    let
        hslColor = "hsl(" + hsl.h + ", 100%, 50%)",
        style = {
            backgroundColor: hslColor
        }
  return (
    <div className="color-picker-pointer-hue" style={style}></div>
  )
}

export default PointerCircle
